import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { campaignMessages as messages } from './campaignMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the setup; each part uses its own slice of it */
import styles from './Builder.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface StepBarProps {
  /** "Cancel" on the first step, else "Back". */
  backKind?: 'back' | 'cancel';
  onBack?: () => void;
  /** The line in the middle (what the step set), or the reason Next is off. */
  summary?: string;
  nextLabel: string;
  onNext?: () => void;
  nextDisabled?: boolean;
  isSaving?: boolean;
  /** Replaces the Next button (the start bar of step 5 has its own buttons). */
  right?: React.ReactNode;
}

/**
 * The bar at the end of each step (design outreach-v2 b1 `stepbar`): Back or Cancel on the left,
 * a summary line, Next on the right. It sticks to the bottom on a phone (b3).
 */
const StepBarComponent: React.FC<StepBarProps> = ({
  backKind = 'back',
  onBack,
  summary,
  nextLabel,
  onNext,
  nextDisabled = false,
  isSaving = false,
  right,
}) => {
  const intl = useIntl();
  return (
    <div className={styles.stepBar} data-testid="builder-step-bar">
      {onBack !== undefined && (
        <SMLButton size="sm" color="link" omitCap onClick={onBack}>
          {intl.formatMessage(backKind === 'cancel' ? messages.cancel : messages.back)}
        </SMLButton>
      )}
      <div className={styles.stepBarMid}>{summary}</div>
      {right ?? (
        <SMLButton
          color="primary"
          omitCap
          onClick={onNext}
          disabled={nextDisabled}
          isLoading={isSaving}
          testID="builder-next"
        >
          {nextLabel}
        </SMLButton>
      )}
    </div>
  );
};

export const StepBar = TypedMemo(StepBarComponent);
